import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { Input } from 'sr/helpers'
export const JobTitleChange = forwardRef((props: any, ref) => {
  const [jobTitle, setJobTitle] = useState('');
  const [error, setError] = useState('');
  const data = {
    job_title:jobTitle
  }
  useEffect(()=> {
setJobTitle(props?.data?.job_title)
  },[props?.data])
  useEffect(()=> {
    props.HandleDataProps(data)
  },[jobTitle])

  useImperativeHandle(ref, () => ({
    validateData: () => {
      const isValid = !!jobTitle?.trim();
      if (!isValid) setError('Job title is required');
      return isValid;
    }
  }));

  return (
    <div className='py-4'>
    <Input onChange={(e:any)=> setJobTitle(e.target.value) } value={jobTitle} InputDivClass="mt-0" inputClass = "border border-zinc-800 rounded-lg h-11" label="Job Title"></Input>
      {error && (
        <div className="text-red-500 text-sm mt-2">
          {error}
        </div>
      )}
</div>
  );
});
